import moment from "moment";

export default class WorkshopView {
  constructor(data) {
    this.id = data.id;
    this.topic = data.topic;
    this.description = data.description;
    this.start_time = data.startTime ? moment(data.startTime) : null;
    this.end_time = data.endTime ? moment(data.endTime) : null;
    this.joined = data.attending;
    this.num_spots_left = data.remainingSeats;
    this.struggle_areas = data.specialties;
    this.meeting_id = data.meetingId;
    this.host = data.counselor 
      ? {
        id: data.counselor.id,
        first_name: data.counselor.firstName,
        last_name: data.counselor.lastName,
        name: `${data.counselor.firstName} ${data.counselor.lastName}`,
      } 
      : null

    this.cost = 4000;
    this.canJoin = this.num_spots_left > 0;
    this.endsOnDifferentDay = 
      this.start_time.year !== this.end_time.year 
      || this.start_time.month !== this.end_time.month
      || this.start_time.date !== this.end_time.date;
  }
}